import { useEffect, useState } from 'react';
import { VisuallyHidden } from '@mantine/core';
import { JOB_ANNOUNCE_DELAY_MS, subscribeJobAnnouncements } from '@services/backgroundJobs/jobAnnouncer';

/** Постоянная live-область шапки для объявлений фоновых задач, которые больше негде произнести. */
const JobLiveAnnouncer = () => {
    const [text, setText] = useState('');

    useEffect(() => {
        let timer: number | undefined;
        const unsubscribe = subscribeJobAnnouncements((next) => {
            window.clearTimeout(timer);
            setText('');
            timer = window.setTimeout(() => setText(next), JOB_ANNOUNCE_DELAY_MS);
        });
        return () => {
            window.clearTimeout(timer);
            unsubscribe();
        };
    }, []);

    return (
        <VisuallyHidden role="status" aria-live="polite" aria-atomic="true">
            {text}
        </VisuallyHidden>
    );
};

export default JobLiveAnnouncer;
